export default (props, vars) =>
  !vars?.['useapplicationoffer2']?.['isLoading'] &&
  [
    vars?.['useapplicationoffer2']?.['applicationOffer'].STAGES.ACCEPTED,
    vars?.['useapplicationoffer2']?.['applicationOffer'].STAGES.ENROLLED,
  ].includes(vars?.['useapplicationoffer2']?.['applicationOffer']?.stage_id) &&
  !vars?.isInViewOfferDetailsMode;
